import { useMaterialResourceStore } from './useMaterialResourceStore'

export default function useMaterialResources({
  projectId,
}: {
  projectId?: string
}) {
  const {
    records,
    recordsWithDeletedItems,
    loading,
    isReady,
    schema,
    save,
    store,
  } = useMaterialResourceStore(projectId)

  return {
    records,
    recordsWithDeletedItems,
    loading,
    isReady,
    schema,
    save,
    controlCommands: store.controls,
  }
}
